import React from 'react';
import { useSelector } from 'react-redux';
import { useConfig } from '../../../config/context';
import { viewportWidthSelector } from '../../../store/app/selector';
import { Size } from '../../enums/size';
import { SearchForm } from '../../molecules/SearchForm';
import { NavigationContainer } from '../../organism/NavigationContainer';
import { SupportLink } from '../SupportLink';
import * as styles from './mobile_menu.module.sass';
import { MobileMenuProps } from './props.types';

export const MobileMenu = (props: MobileMenuProps) => {
  const config = useConfig();
  const mobileView = useSelector(viewportWidthSelector);

  return (
    <>
      {mobileView < config.MEDIAQUERY.MOBILE && <SearchForm />}

      <NavigationContainer titles={props.topTitles} nav_link size={Size.MEDIUM} mobile_display />

      <NavigationContainer
        titles={props.titles}
        size={Size.MEDIUM}
        liClassName={styles.li_retreat}
        mobile_laptop_display
        label
      />


      <div className={styles.support_modal}>
        <a href={`tel: ${config.PHONES.SUPPORT}`}>{config.PHONES.SUPPORT}</a>
        <SupportLink className={styles.support_nav} />
      </div>
      {props.children}
    </>
  );
};
